import React from "react";

export const InfoIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.8668 8.7072C5.8668 9.0384 5.598 9.3072 5.2668 9.3072C4.9356 9.3072 4.6668 9.0384 4.6668 8.7072C4.6668 8.376 4.9356 8.1072 5.2668 8.1072C5.598 8.1072 5.8668 8.376 5.8668 8.7072ZM3.4668 3C3.4668 2.6688 3.7356 2.4 4.0668 2.4H7.4928C7.9938 2.4 8.4 2.8062 8.4 3.3072V4.8C8.4 5.46 7.86 6 7.2 6H6.3054C6.1368 6 6 6.1368 6 6.3054V6.9072C6 7.2384 5.7318 7.5072 5.4 7.5072C5.0688 7.5072 4.8 7.2384 4.8 6.9072V5.86681C4.8 5.27761 5.2776 4.8 5.8668 4.8H6.4668C6.798 4.8 7.0668 4.5312 7.0668 4.2C7.0668 3.8688 6.798 3.6 6.4668 3.6H4.0668C3.7356 3.6 3.4668 3.3312 3.4668 3ZM10.2 10.8H1.8C1.4688 10.8 1.2 10.5312 1.2 10.2V1.8C1.2 1.4688 1.4688 1.2 1.8 1.2H10.2C10.5318 1.2 10.8 1.4688 10.8 1.8V10.2C10.8 10.5312 10.5318 10.8 10.2 10.8ZM0 1.2V10.8C0 11.463 0.537604 12 1.2 12H10.8C11.463 12 12 11.463 12 10.8V1.2C12 0.5376 11.463 0 10.8 0H1.2C0.537604 0 0 0.5376 0 1.2Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};
